import RestService from './RestService';
import KeyBehaviourService from './KeyBehaviourService';

export default class Tags extends RestService {
    constructor() {
        super('/threatAreas');
    }

    listSuper() {
        return this.get(`${this.baseUrl}/listSuper`);
    }

    KeyBehaviorService(threatAreaId) {
        return new KeyBehaviourService(this, threatAreaId);
    }
}
